import stylesheet0 from "@oneappexchange/appx-font-utilities";

function stylesheet(token, useActualHostSelector, useNativeDirPseudoclass) {
  var shadowSelector = token ? ("[" + token + "]") : "";
  var hostSelector = token ? ("[" + token + "-host]") : "";
  var suffixToken = token ? ("-" + token) : "";
  return "a" + shadowSelector + " {display: flex;align-items: center;color: var(--sds-g-color-palette-blue-50);text-decoration: none;font-size: var(--wes-g-font-size-2);padding-left: var(--sds-g-spacing-2);padding-top: var(--sds-g-spacing-2);}a:hover" + shadowSelector + " {color: var(--sds-g-color-palette-blue-20);text-decoration: underline;}ads-icon" + shadowSelector + " {margin-left: var(--sds-g-spacing-2);}";
  /*LWC compiler v7.1.3*/
}
export default [stylesheet0, stylesheet];